import getObjects from '@/handlers/getObjects';

export default function (files, storageAccessLevel, storagePath) {
  return {
    data() {
      return {
        files,
        storageAccessLevel,
        storagePath,
      };
    },
    async created() {
      await this.generateFilelist();
    },
    methods: {
      async generateFilelist() {
        const fileObjects = await getObjects(this.storageAccessLevel, this.storagePath);

        // create a map of files by topic
        fileObjects.forEach((fileObject) => {
          // By key, figure out which topic the file belongs to
          const topicKey = Object.keys(this.files)
            .find(_topicKey => fileObject.Key.indexOf(_topicKey) !== -1);
          // Ignore files that are not in the topic list
          if (!topicKey) {
            return;
          }

          // add file to topic or if it already exists, update it
          const fileIndex = this.files[topicKey].files
            .findIndex(file => file.Key === fileObject.Key);
          if (fileIndex !== -1) {
            this.files[topicKey].files[fileIndex] = fileObject;
          } else {
            this.files[topicKey].files.push(fileObject);
          }
        });

        // remove files that are not in the fileObjects list
        // this is needed when a file is deleted
        Object.keys(this.files).forEach((topicKey) => {
          this.files[topicKey].files = this.files[topicKey].files
            .filter(file => fileObjects.map(_file => _file.key).includes(file.key));
        });

        // sort files by predefined rules
        this.sortFiles();
      },
      sortFiles() {
        Object.keys(this.files).forEach((topicKey) => {
          this.files[topicKey].files.sort((a, b) => {
            try {
              // alias is stored as metadata the database (separate from the file object)
              // And, as they are stored sepparatly, there can always be a state where
              // one exists without the other.
              // In other words the alias can be undefined.
              if (typeof a.alias === 'undefined') {
                return 1;
              }
              if (typeof b.alias === 'undefined') {
                return -1;
              }

              const isOverviewA = a.alias.toLowerCase().indexOf('overview') !== -1;
              const isOverviewB = b.alias.toLowerCase().indexOf('overview') !== -1;
              // in case both OR neither are overview files
              if ((isOverviewA && isOverviewB) || (!isOverviewA && !isOverviewB)) {
                // secondary sort files by alias => sort by alias
                if (a.alias.toLowerCase() < b.alias.toLowerCase()) {
                  return -1;
                }
                if (a.alias.toLowerCase() > b.alias.toLowerCase()) {
                  return 1;
                }
              }

              // priorotized sort overview files to the top
              if (isOverviewA) {
                return -1;
              }
              if (isOverviewB) {
                return 1;
              }
            } catch (e) {
              return 0;
            }

            return 0;
          });
        });
      },
    },
  };
}
